export const BILLING_PRACTICE_NUMBER = '0904287';
export const TREATING_PRACTICE_NUMBER = '0904287';
export const PLATFORM_NAME = 'Insight';
